import { useQuery } from '@tanstack/react-query';
import { fetchFeeReferenceData } from '../services/productFees';

export const feeReferenceDataKey = ['smr-admin', 'fee-reference-data'] as const;

export function useFeeReferenceDataQuery() {
    return useQuery({
        queryKey: feeReferenceDataKey,
        queryFn: fetchFeeReferenceData,
        staleTime: 1000 * 60 * 30,
    });
}
